import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

const legalPages = {
  impressum: {
    title: 'Impressum',
    content: `
# Impressum

## Angaben gemäß § 5 TMG

Creo Farm
[Straße und Hausnummer]
[PLZ] [Stadt]
Deutschland

## Kontakt

E-Mail: kontakt@creofarm.com
Telegram: @creofarm

## Umsatzsteuer-Identifikationsnummer

Umsatzsteuer-Identifikationsnummer gemäß § 27 a Umsatzsteuergesetz:
[USt-IdNr.]

## Verantwortlich für den Inhalt nach § 55 Abs. 2 RStV

[Name des Verantwortlichen]
[Adresse]

## Streitschlichtung

Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS) bereit: https://ec.europa.eu/consumers/odr/

Unsere E-Mail-Adresse finden Sie oben im Impressum.

Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle teilzunehmen.
    `
  },
  datenschutz: {
    title: 'Datenschutzerklärung',
    content: `
# Datenschutzerklärung

## 1. Datenschutz auf einen Blick

### Allgemeine Hinweise

Die folgenden Hinweise geben einen einfachen Überblick darüber, was mit Ihren personenbezogenen Daten passiert, wenn Sie diese Website besuchen. Personenbezogene Daten sind alle Daten, mit denen Sie persönlich identifiziert werden können.

### Datenerfassung auf dieser Website

**Wer ist verantwortlich für die Datenerfassung auf dieser Website?**

Die Datenverarbeitung auf dieser Website erfolgt durch den Websitebetreiber. Dessen Kontaktdaten können Sie dem Impressum dieser Website entnehmen.

**Wie erfassen wir Ihre Daten?**

Ihre Daten werden zum einen dadurch erhoben, dass Sie uns diese mitteilen. Hierbei kann es sich z.B. um Daten handeln, die Sie bei einer Bestellung angeben.

Andere Daten werden automatisch beim Besuch der Website durch unsere IT-Systeme erfasst. Das sind vor allem technische Daten (z.B. Internetbrowser, Betriebssystem oder Uhrzeit des Seitenaufrufs).

**Wofür nutzen wir Ihre Daten?**

Ein Teil der Daten wird erhoben, um eine fehlerfreie Bereitstellung der Website zu gewährleisten. Andere Daten können zur Analyse Ihres Nutzerverhaltens verwendet werden.

## 2. Hosting und Content Delivery Networks (CDN)

Diese Website wird extern gehostet. Die personenbezogenen Daten, die auf dieser Website erfasst werden, werden auf den Servern des Hosters gespeichert.

## 3. Allgemeine Hinweise und Pflichtinformationen

### Datenschutz

Die Betreiber dieser Seiten nehmen den Schutz Ihrer persönlichen Daten sehr ernst. Wir behandeln Ihre personenbezogenen Daten vertraulich und entsprechend der gesetzlichen Datenschutzvorschriften sowie dieser Datenschutzerklärung.

### Hinweis zur verantwortlichen Stelle

Die verantwortliche Stelle für die Datenverarbeitung auf dieser Website ist im Impressum angegeben.

## 4. Zahlungsdienstleister

### PayPal

Wir bieten Zahlung über PayPal an. PayPal ist ein Service der PayPal (Europe) S.à r.l. et Cie, S.C.A., 22-24 Boulevard Royal, L-2449 Luxembourg.

Wenn Sie mit PayPal bezahlen, erfolgt eine Übermittlung der von Ihnen eingegebenen Zahlungsdaten an PayPal.
    `
  },
  agb: {
    title: 'Allgemeine Geschäftsbedingungen',
    content: `
# Allgemeine Geschäftsbedingungen

## § 1 Geltungsbereich

(1) Diese Allgemeinen Geschäftsbedingungen (nachfolgend "AGB") gelten für alle Verträge, die zwischen Creo Farm (nachfolgend "Verkäufer") und dem Kunden (nachfolgend "Käufer") über den Online-Shop geschlossen werden.

(2) Die AGB gelten ausschließlich. Abweichende, entgegenstehende oder ergänzende AGB des Käufers werden nur dann Vertragsbestandteil, wenn und soweit der Verkäufer ihrer Geltung ausdrücklich zugestimmt hat.

## § 2 Vertragsschluss

(1) Die Darstellung der Produkte im Online-Shop stellt kein rechtlich bindendes Angebot, sondern eine Aufforderung zur Bestellung dar.

(2) Durch Anklicken des Buttons "Kaufen" im letzten Schritt des Bestellvorgangs gibt der Käufer ein verbindliches Angebot zum Kauf der im Warenkorb enthaltenen Waren ab.

(3) Die Annahme des Angebots erfolgt durch Bestätigung per E-Mail oder durch Lieferung der Ware.

## § 3 Preise und Zahlung

(1) Alle Preise verstehen sich inklusive der gesetzlichen Mehrwertsteuer und zuzüglich eventueller Versandkosten.

(2) Die Zahlung erfolgt über PayPal.

## § 4 Lieferung

(1) Die Lieferzeit beträgt, sofern nicht beim Angebot anders angegeben, bei lagernden Artikeln 3-5 Werktage.

(2) Bei Artikeln, die auf Bestellung gefertigt werden ("Made to Order"), beträgt die Produktionszeit in der Regel 2-4 Wochen.

## § 5 Eigentumsvorbehalt

Die Ware bleibt bis zur vollständigen Bezahlung Eigentum des Verkäufers.

## § 6 Gewährleistung

Es gelten die gesetzlichen Gewährleistungsrechte.

## § 7 Schlussbestimmungen

(1) Es gilt das Recht der Bundesrepublik Deutschland.

(2) Sollten einzelne Bestimmungen dieser AGB unwirksam sein oder werden, bleibt die Wirksamkeit der übrigen Bestimmungen davon unberührt.
    `
  },
  widerruf: {
    title: 'Widerrufsbelehrung',
    content: `
# Widerrufsbelehrung

## Widerrufsrecht

Sie haben das Recht, binnen vierzehn Tagen ohne Angabe von Gründen diesen Vertrag zu widerrufen.

Die Widerrufsfrist beträgt vierzehn Tage ab dem Tag, an dem Sie oder ein von Ihnen benannter Dritter, der nicht der Beförderer ist, die Waren in Besitz genommen haben bzw. hat.

Um Ihr Widerrufsrecht auszuüben, müssen Sie uns

Creo Farm
[Adresse]
E-Mail: kontakt@creofarm.com

mittels einer eindeutigen Erklärung (z.B. ein mit der Post versandter Brief oder E-Mail) über Ihren Entschluss, diesen Vertrag zu widerrufen, informieren.

## Folgen des Widerrufs

Wenn Sie diesen Vertrag widerrufen, haben wir Ihnen alle Zahlungen, die wir von Ihnen erhalten haben, einschließlich der Lieferkosten (mit Ausnahme der zusätzlichen Kosten, die sich daraus ergeben, dass Sie eine andere Art der Lieferung als die von uns angebotene, günstigste Standardlieferung gewählt haben), unverzüglich und spätestens binnen vierzehn Tagen ab dem Tag zurückzuzahlen, an dem die Mitteilung über Ihren Widerruf dieses Vertrags bei uns eingegangen ist.

Für diese Rückzahlung verwenden wir dasselbe Zahlungsmittel, das Sie bei der ursprünglichen Transaktion eingesetzt haben, es sei denn, mit Ihnen wurde ausdrücklich etwas anderes vereinbart.

Sie haben die Waren unverzüglich und in jedem Fall spätestens binnen vierzehn Tagen ab dem Tag, an dem Sie uns über den Widerruf dieses Vertrags unterrichten, an uns zurückzusenden oder zu übergeben.

Sie tragen die unmittelbaren Kosten der Rücksendung der Waren.

## Ausschluss des Widerrufsrechts

Das Widerrufsrecht besteht nicht bei Verträgen zur Lieferung von Waren, die nicht vorgefertigt sind und für deren Herstellung eine individuelle Auswahl oder Bestimmung durch den Verbraucher maßgeblich ist oder die eindeutig auf die persönlichen Bedürfnisse des Verbrauchers zugeschnitten sind.
    `
  }
};

export default function LegalPage({ type }) {
  const page = legalPages[type];

  if (!page) {
    return (
      <div className="min-h-screen bg-[#0A0A0A] flex items-center justify-center pt-24">
        <div className="text-center">
          <h1 className="text-2xl text-white mb-4">Page not found</h1>
          <Link to="/" className="text-indigo-400 hover:text-indigo-300">Back to home</Link>
        </div>
      </div>
    );
  }

  return (
    <div data-testid={`legal-${type}-page`} className="min-h-screen bg-[#0A0A0A] pt-24">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <Link
          to="/"
          className="inline-flex items-center space-x-2 text-zinc-400 hover:text-white mb-8 transition-colors"
        >
          <ArrowLeft className="w-4 h-4" />
          <span>Back to Home</span>
        </Link>

        <article className="prose prose-invert prose-zinc max-w-none">
          <div 
            className="[&_h1]:text-3xl [&_h1]:font-['Outfit'] [&_h1]:font-medium [&_h1]:text-white [&_h1]:mb-8
                       [&_h2]:text-xl [&_h2]:font-['Outfit'] [&_h2]:font-medium [&_h2]:text-white [&_h2]:mt-8 [&_h2]:mb-4
                       [&_h3]:text-lg [&_h3]:font-medium [&_h3]:text-white [&_h3]:mt-6 [&_h3]:mb-3
                       [&_p]:text-zinc-400 [&_p]:leading-relaxed [&_p]:mb-4
                       [&_strong]:text-white
                       [&_a]:text-indigo-400 [&_a]:hover:text-indigo-300
                       [&_ul]:text-zinc-400 [&_ul]:list-disc [&_ul]:pl-6 [&_ul]:mb-4
                       [&_ol]:text-zinc-400 [&_ol]:list-decimal [&_ol]:pl-6 [&_ol]:mb-4
                       [&_li]:mb-2"
            dangerouslySetInnerHTML={{ __html: page.content.replace(/\n/g, '<br/>').replace(/#{1,6}\s+(.+)/g, (match, content) => {
              const level = match.trim().split(' ')[0].length;
              return `<h${level}>${content}</h${level}>`;
            }) }}
          />
        </article>
      </div>
    </div>
  );
}
